import { VCardText } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCardText,[_c('div',{staticClass:"overflow-y-auto",style:(`height: ${_vm.height}px`),attrs:{"id":"vcardtext"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }